import React from 'react';
import load from '../hocs/load';
var FixedLeftFluidLayout = load(function () {
  return import('../layouts/FixedLeftFluidLayout/FixedLeftFluidLayout');
});
var BalancesMenuContainer = load(function () {
  return import('../components/BalancesMenu/BalanceMenuContainer');
});
var WalletDetailsBackButtonComponent = load(function () {
  return import('../components/WalletDetails/WalletDetailsBackButtonComponent');
});
var DualHeaderDashboardLayout = load(function () {
  return import('../layouts/DualHeaderLayouts/DualHeaderDashboardLayout');
});
var SubNavComponent = load(function () {
  return import('../components/SubNavRow/SubNavRowComponent');
});
var TransferRequestNotificationList = load(function () {
  return import('../components/TransferRequestsNotification/');
});
var TradingLayout = load(function () {
  return import('../layouts/TradingLayout/TradingLayoutContainer');
});
var BalancesListLayout = load(function () {
  return import('../layouts/BalancesListLayout/BalancesListLayout');
});
var RecentActivityContainer = load(function () {
  return import('../components/RecentActivity');
});
var RecentActivityWithFilterContainer = load(function () {
  return import('../components/RecentActivityWithFilter');
});
var SingleFluidHeaderFixedContentLayout = load(function () {
  return import('../layouts/SingleFluidHeaderFixedContent/SingleFluidHeaderFixedContent');
});
var ComponentRowSingle = load(function () {
  return import('../layouts/ComponentRow/ComponentRowSingle');
});
var WalletCardGridContainer = load(function () {
  return import('../components/WalletCards/WalletCardGridContainer');
});
var WalletRowListContainer = load(function () {
  return import('../components/WalletRows/WalletRowListContainer');
});
var DualFluidHeaderFixedContentLayout = load(function () {
  return import('../layouts/DualFluidHeaderFixContent/DualFluidHeaderFixedContentLayout');
});
var MarketDataCardsContainer = load(function () {
  return import('../components/MarketDataCardsComponent/MarketDataCardsContainer');
});
var RetailBuySellLayout = load(function () {
  return import('../layouts/BuySellLayout/BuySellLayout');
});
var MarketOverviewLayout = load(function () {
  return import('../layouts/MarketOverviewLayout/MarketOverviewLayout');
});
var PageFooterComponent = load(function () {
  return import('../components/PageFooter/PageFooterComponent');
});
var WalletDetailsLayout = load(function () {
  return import('../layouts/WalletDetailsLayout/WalletDetailsLayout');
});
var IBALayout = load(function () {
  return import('../components/IBA/IbaLayout');
});
var StreamingLayout = load(function () {
  return import('../layouts/StreamingLayouts/StreamingLayout');
});
var StreamingGridContainer = load(function () {
  return import('../components/Streaming/StreamingGridContainer');
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
// this.context.t('User Settings')
export var mainNavOptions = {
  mainNavItems: [{
    text: 'Dashboard',
    icon: 'dashboard',
    path: '/dashboard'
  }, {
    text: 'Exchange',
    icon: 'trading',
    path: '/exchange'
  }, {
    text: 'Streaming',
    icon: 'buy-sell',
    path: '/streaming'
  }, {
    text: 'Yield',
    icon: 'sell',
    path: '/iba'
  }, {
    text: 'Buy & Sell',
    icon: 'buy-sell',
    path: '/buy-sell'
  }, {
    text: 'Wallets',
    icon: 'wallet',
    path: '/wallets'
  }, {
    text: 'User Settings',
    icon: 'user-settings',
    path: '/settings/profile'
  }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
export var subNavItems = [{
  text: 'Your Snapshot',
  path: '/dashboard'
}, {
  text: 'Market Data',
  path: '/dashboard/market-data'
}];
export var walletsPath = '/wallets';
export var walletDetailPath = '/wallets/wallet-detail';
export var marginBalancesPath = '/margin-balances';
export var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return React.createElement(DualHeaderDashboardLayout, {
      headerSecondary: React.createElement(SubNavComponent, null),
      notificationComponent: React.createElement(TransferRequestNotificationList, null),
      component1: React.createElement(MarketOverviewLayout, null),
      component2: React.createElement(BalancesListLayout, null),
      component3: React.createElement(RecentActivityContainer, {
        filterForSelected: false
      }),
      footer: React.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return React.createElement(DualFluidHeaderFixedContentLayout, {
      headerSecondary: React.createElement(SubNavComponent, null),
      footer: React.createElement(PageFooterComponent, null)
    }, React.createElement(ComponentRowSingle, {
      component: React.createElement(MarketDataCardsContainer, null)
    }));
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return React.createElement(RetailBuySellLayout, {
      footer: React.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/exchange',
  render: function render() {
    return React.createElement(TradingLayout, null);
  }
}, {
  exact: true,
  path: '/streaming',
  render: function render() {
    return React.createElement(StreamingLayout, {
      component1: React.createElement(StreamingGridContainer, null),
      component2: React.createElement(BalancesListLayout, null),
      component3: React.createElement(RecentActivityWithFilterContainer, {
        filterForSelected: false,
        pageSize: 10,
        minRow: 10
      }),
      footer: React.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/iba',
  render: function render() {
    return React.createElement(IBALayout, null);
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return React.createElement(SingleFluidHeaderFixedContentLayout, {
      footer: React.createElement(PageFooterComponent, null)
    }, React.createElement(ComponentRowSingle, {
      header: 'Funded Accounts',
      component: React.createElement(WalletCardGridContainer, {
        detailsLink: walletDetailPath
      })
    }), React.createElement(ComponentRowSingle, {
      customClass: 'container-with-shadow',
      header: 'Unfunded Accounts',
      component: React.createElement(WalletRowListContainer, {
        detailsLink: walletDetailPath
      })
    }));
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return React.createElement(FixedLeftFluidLayout, {
      left: [React.createElement(WalletDetailsBackButtonComponent, {
        key: '1'
      }), React.createElement(BalancesMenuContainer, {
        key: '2'
      })]
    }, React.createElement(WalletDetailsLayout, null));
  }
}];